import Phaser from 'phaser';
import { CANVAS_W, CANVAS_H } from '../types';
import { AudioManager } from '../systems/AudioManager';

const VOLUME_STEPS = 5;

export class SettingsScene extends Phaser.Scene {
  private muteText!: Phaser.GameObjects.Text;
  private volText!: Phaser.GameObjects.Text;
  private items!: Phaser.GameObjects.Text[];
  private cursor = 0;
  private keys!: { up: Phaser.Input.Keyboard.Key; down: Phaser.Input.Keyboard.Key; confirm: Phaser.Input.Keyboard.Key; back: Phaser.Input.Keyboard.Key };

  constructor() { super('SettingsScene'); }

  create() {
    this.add.text(CANVAS_W / 2, 80, '⚙️  SETĂRI', {
      fontFamily: 'monospace', fontSize: '28px', color: '#ffd166',
    }).setOrigin(0.5);

    this.add.text(CANVAS_W / 2, 120, 'Tasta ESC sau BACK pentru a reveni', {
      fontFamily: 'monospace', fontSize: '12px', color: '#666',
    }).setOrigin(0.5);

    this.muteText = this.add.text(CANVAS_W / 2, 200, this.muteLabel(), {
      fontFamily: 'monospace', fontSize: '20px',
    }).setOrigin(0.5).setInteractive({ useHandCursor: true });

    this.volText = this.add.text(CANVAS_W / 2, 250, this.volLabel(), {
      fontFamily: 'monospace', fontSize: '20px',
    }).setOrigin(0.5).setInteractive({ useHandCursor: true });

    const backText = this.add.text(CANVAS_W / 2, 320, '← ÎNAPOI', {
      fontFamily: 'monospace', fontSize: '18px', color: '#a8dadc',
    }).setOrigin(0.5).setInteractive({ useHandCursor: true });

    this.items = [this.muteText, this.volText, backText];

    this.muteText.on('pointerdown', () => this.toggleMute());
    this.volText.on('pointerdown', (pointer: Phaser.Input.Pointer) => {
      pointer.x < CANVAS_W / 2 ? this.adjustVolume(-1) : this.adjustVolume(1);
    });
    backText.on('pointerdown', () => this.goBack());

    this.muteText.on('pointerover', () => { this.cursor = 0; this.redraw(); });
    this.volText.on('pointerover', () => { this.cursor = 1; this.redraw(); });
    backText.on('pointerover', () => { this.cursor = 2; this.redraw(); });

    const kb = this.input.keyboard!;
    this.keys = {
      up: kb.addKey(Phaser.Input.Keyboard.KeyCodes.UP),
      down: kb.addKey(Phaser.Input.Keyboard.KeyCodes.DOWN),
      confirm: kb.addKey(Phaser.Input.Keyboard.KeyCodes.ENTER),
      back: kb.addKey(Phaser.Input.Keyboard.KeyCodes.ESC),
    };

    this.redraw();
  }

  update() {
    if (Phaser.Input.Keyboard.JustDown(this.keys.up)) {
      this.cursor = (this.cursor - 1 + this.items.length) % this.items.length;
      AudioManager.sfx('menu-move');
      this.redraw();
    }
    if (Phaser.Input.Keyboard.JustDown(this.keys.down)) {
      this.cursor = (this.cursor + 1) % this.items.length;
      AudioManager.sfx('menu-move');
      this.redraw();
    }
    if (Phaser.Input.Keyboard.JustDown(this.keys.confirm)) {
      if (this.cursor === 0) this.toggleMute();
      else if (this.cursor === 1) this.adjustVolume(1);
      else this.goBack();
    }
    if (Phaser.Input.Keyboard.JustDown(this.keys.back)) {
      this.goBack();
    }
  }

  private muteLabel(): string {
    return AudioManager.isMuted ? '🔇 SUNET: OFF   [apasă pentru ON ]' : '🔊 SUNET: ON    [apasă pentru OFF]';
  }

  private volLabel(): string {
    const bars = Math.round(AudioManager.volume * VOLUME_STEPS);
    const bar = '█'.repeat(bars) + '░'.repeat(VOLUME_STEPS - bars);
    return `◄ VOLUM: [${bar}] ►`;
  }

  private toggleMute() {
    AudioManager.toggleMute();
    AudioManager.sfx('menu-select');
    this.muteText.setText(this.muteLabel());
    this.redraw();
  }

  private adjustVolume(dir: 1 | -1) {
    const step = 1 / VOLUME_STEPS;
    AudioManager.setVolume(AudioManager.volume + dir * step);
    if (!AudioManager.isMuted) AudioManager.sfx('menu-move');
    this.volText.setText(this.volLabel());
    this.redraw();
  }

  private goBack() {
    AudioManager.sfx('menu-select');
    this.scene.start('MenuScene');
  }

  private redraw() {
    this.items.forEach((t, i) => {
      t.setColor(i === this.cursor ? '#ffd166' : '#cccccc');
    });
  }
}
